import { DateField, Select } from '@evogard/ui';
import { businessDate } from '@evogard/domain';

/**
 * O período do mapa do time — por mês ou por intervalo, como no painel do
 * Financeiro. O mês é o corrente ao abrir.
 */
export type TeamMapPeriod = {
  kind: 'mes' | 'intervalo';
  month: string;
  from: string;
  to: string;
};

export const initialPeriod = (): TeamMapPeriod => ({
  kind: 'mes',
  month: businessDate(new Date()).slice(0, 7),
  from: '',
  to: '',
});

/** O intervalo que a consulta leva, e por que ela ainda não pode sair. */
export function periodRange(p: TeamMapPeriod) {
  const range = p.kind === 'mes' ? monthRange(p.month) : { from: p.from, to: p.to };
  const incomplete = !range.from || !range.to;
  return { ...range, incomplete, inverted: !incomplete && range.from > range.to };
}

export function PeriodFields({
  value,
  onChange,
}: {
  value: TeamMapPeriod;
  onChange: (p: TeamMapPeriod) => void;
}) {
  return (
    <>
      <div className="w-44">
        <Select
          label="Período"
          value={value.kind}
          onChange={(e) =>
            onChange({ ...value, kind: e.target.value as TeamMapPeriod['kind'] })
          }
        >
          <option value="mes">Por mês</option>
          <option value="intervalo">Intervalo</option>
        </Select>
      </div>
      {value.kind === 'mes' ? (
        <div className="w-52">
          <Select
            label="Mês"
            value={value.month}
            onChange={(e) => onChange({ ...value, month: e.target.value })}
          >
            {recentMonths().map((m) => (
              <option key={m} value={m}>
                {monthLabel(m)}
              </option>
            ))}
          </Select>
        </div>
      ) : (
        <>
          <div className="w-44">
            <DateField
              label="De"
              value={value.from}
              onChange={(from) => onChange({ ...value, from })}
            />
          </div>
          <div className="w-44">
            <DateField
              label="Até"
              value={value.to}
              onChange={(to) => onChange({ ...value, to })}
            />
          </div>
        </>
      )}
    </>
  );
}

/** `AAAA-MM` → do dia 1 ao último dia do mês. */
function monthRange(month: string): { from: string; to: string } {
  const [y, m] = month.split('-').map(Number) as [number, number];
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return { from: `${month}-01`, to: `${month}-${String(last).padStart(2, '0')}` };
}

/** Os doze meses até o corrente, do mais novo para o mais velho. */
function recentMonths(): string[] {
  const [y, m] = businessDate(new Date()).split('-').map(Number) as [number, number];
  return Array.from({ length: 12 }, (_, i) =>
    new Date(Date.UTC(y, m - 1 - i, 1)).toISOString().slice(0, 7),
  );
}

function monthLabel(month: string): string {
  const [y, m] = month.split('-').map(Number) as [number, number];
  return new Date(Date.UTC(y, m - 1, 15)).toLocaleDateString('pt-BR', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
